import { render, staticRenderFns } from "./LprRelieveIcon.vue?vue&type=template&id=6a32cbca&scoped=true"
import script from "./LprRelieveIcon.vue?vue&type=script&lang=js"
export * from "./LprRelieveIcon.vue?vue&type=script&lang=js"
import style0 from "./LprRelieveIcon.vue?vue&type=style&index=0&id=6a32cbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a32cbca",
  null
  
)

export default component.exports